import cloneDeep from 'lodash/cloneDeep'
import Avatar from '@/models-ts/user/Avatar'

export default class IndividualInfo {
  avatar: Avatar | null
  website: string
  internalCountryId: number | null
  description: string

  constructor({ avatar = null, website = '', description = '', internalCountryId = null }: Partial<IndividualInfo>) {
    Object.assign(
      this,
      cloneDeep({
        avatar,
        website,
        description,
        internalCountryId,
      })
    )
  }

  static fromServer(props: LX.IndividualInfo) {
    return new IndividualInfo({
      avatar: Array.isArray(props.relations.avatar) && props.relations.avatar?.length ? Avatar.fromServer(props.relations.avatar) : null,
      website: props.individual_website || '',
      description: props.individual_description || '',
      internalCountryId: props.internal_country_id,
    })
  }

  toServer() {
    return {
      individual_description: this.description.trim(),
      individual_website: this.website.trim(),
      internal_country_id: this.internalCountryId,
    }
  }
}
